import React from "react";
import { ColumnsType } from "antd/es/table";
import type { SortOrder } from "antd/es/table/interface";
import { TFunction } from "i18next";

import Green from "~/assets/img/green-icon.png";
import Status from "~/pages/BaseStaff/ViewingBaseStaff/ui/Status";
import { StatusSelectOptions } from "~/pages/BaseStaff/options";
import {
  getLocalizedSortableApiKeys,
  localizedSortFieldForApi,
} from "~/shared/lib/localizedSortField";

export const getBaseStaffSortableApiKeys = (
  visibleOptions: string[],
  lang: string | null | undefined,
) =>
  getLocalizedSortableApiKeys(
    visibleOptions.filter((opt) => opt !== "positions"),
    lang,
  );

export const baseStaffSortFieldForOrderBy = (field?: string) => {
  if (field === "statusEn") return "status";
  return field;
};

const sortOrderFor = (
  sortKey: string,
  sortField?: string,
  sortType?: string,
): SortOrder | undefined => {
  if (sortField !== sortKey) return undefined;
  if (sortType === "ASC") return "ascend";
  if (sortType === "DESC") return "descend";
  return undefined;
};

export const getBaseStaffColumns = (
  t: TFunction,
  options: string[],
  refetch: () => void,
  sortField?: string,
  sortType?: string,
  lang?: string | null,
): ColumnsType<any> =>
  options.map((option) => {
    const sortKey = localizedSortFieldForApi(option, lang);
    const columnSortable = option !== "positions";
    const sortOrder = sortOrderFor(sortKey, sortField, sortType);

    const baseColumn = {
      title:
        option === "dealerCenter"
          ? t("employee.organization")
          : t(`employee.${option}`),
      dataIndex: option,
      key: sortKey,
      sorter: columnSortable,
      sortOrder: columnSortable ? sortOrder : undefined,
    };

    if (option === "status") {
      return {
        ...baseColumn,
        width: 200,
        render: (_value: unknown, record: Record<string, unknown>) => (
          <Status
            refetch={refetch}
            statusValue={StatusSelectOptions.find(
              (el) => el.value === record.rawPositionStatus,
            )}
            EmployeeId={String(record.id ?? "")}
            allowedRolesForEditing={
              Array.isArray(record.roles) ? (record.roles as string[]) : []
            }
            positionId={String(record.employeePositionInstanceId ?? "")}
            rejectReason={
              typeof record.message === "string" ? record.message : undefined
            }
            instanceId={record.instanceId as string | number | undefined}
          />
        ),
      };
    }

    if (option === "verifiedInDnm") {
      return {
        ...baseColumn,
        render: (value: any, record: any) =>
          record.verifiedInDnm ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img src={Green} alt="Верификация" />
            </div>
          ) : null,
      };
    }

    return {
      ...baseColumn,
      render: (value: any) => <span>{value}</span>,
    };
  });
